module.exports = __webpack_public_path__ + "media/Seyi Shay - Right Now (Remix) ft. Iyanya & Banky W.4c94e683.mp3";